import React from "react";
import { Spring, Transition } from 'react-spring';

import moment from "moment";

import { translate, getLanguage } from "../Translation/Translation";

class OSShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 320,
      height_extra: 0,
      extraInfo: null,
      expanded: true
    };
  }

  componentDidMount() {
    const height = 220 + parseInt(document.getElementById("CARD").clientHeight);
    const height_extra = parseInt(
      document.getElementById("CARD_EXTRA").clientHeight
    );
    this.setState({
      height: height,
      height_extra: height_extra,
      expanded: false
    });
  }


  expandCard = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  renderCard(extraInfo, styles) {
    const { cabins, garage } = this.props;
     // console.log(styles);
    return (
      <div
        className="OSShipCardContainer"
        style={{
          ...styles,
          opacity: 1
        }}
      >
        <div
          className="OSShipIMGContainer"
          style={{
            backgroundImage: `url(${this.props.image})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#edeeee"
          }}
        />
        <div className="OSShipContentContainer" id="CARD">
          <div className="OSShipContentTitle">{this.props.title}</div>
          <hr style={{ margin: "9px 0px 0px 0px" }} />
          <div className="OSShipContentData">
            <span
              className="OSShipContentDataLabel"
              style={{ marginLeft: "0px" }}
            >
              {translate(getLanguage(), "Vessel kind")}: {this.props.kind}
            </span>
          </div>
          {cabins || garage ? (
            <div>
              <div className="OSShipContentData" style={{ marginTop: "10px" }}>
                {this.props.cabins ? (
                  <span className="checkmark">
                    <div className="checkmark_circle" />
                    <div className="checkmark_stem" />
                    <div className="checkmark_kick" />
                  </span>
                ) : (
                  <span className="checkmark_red">
                    <div className="checkmark_circle_red" />
                    <div className="checkmark_stem_1" />
                    <div className="checkmark_stem_2" />
                  </span>
                )}
                <span className="OSShipContentDataLabel">
                  {translate(getLanguage(), "Cabins")}
                </span>
              </div>
              <div className="OSShipContentData">
                {this.props.garage ? (
                  <span className="checkmark">
                    <div className="checkmark_circle" />
                    <div className="checkmark_stem" />
                    <div className="checkmark_kick" />
                  </span>
                ) : (
                  <span className="checkmark_red">
                    <div className="checkmark_circle_red" />
                    <div className="checkmark_stem_1" />
                    <div className="checkmark_stem_2" />
                  </span>
                )}
                <span className="OSShipContentDataLabel">
                  {translate(getLanguage(), "Garage")}
                </span>
              </div>
            </div>
          ) : (
              <div>
                  <div>{extraInfo[0]}</div>
                  <div>{extraInfo.length > 1 && extraInfo[1]}</div>
              </div>
          )}
        </div>
        <span className="OSShipContentExpand" onClick={this.expandCard}>
          {this.state.expanded
            ? translate(getLanguage(), "Collapse")
            : translate(getLanguage(), "Expand")}
        </span>
        
        {this.state.expanded && (
          <div
            id="CARD_EXTRA"
            style={{
              width: "100%",
              background: "#edeeee",
              marginTop: this.state.height - 20,
              opacity: styles.opacity
            }}
          >
            {extraInfo.length > 2 && extraInfo.slice(2)}
          </div>
        )}
        <div className="OSShipCompanyContainer">
          <div
            className="OSShippCompanyIMGContainer"
            style={{
              backgroundImage: `url(${this.props.companyImage})`,
              backgroundPosition: "center",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundColor: "#edeeee"
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    let extraInfo = null;

    if (this.props.accommodations) {
      extraInfo = this.props.accommodations.map(accommodation => {
        return (
          <div
            key={accommodation.name}
            className="OSShipContentData"
            style={{ marginTop: "10px" }}
          >
            {accommodation.available ? (
              <span className="checkmark">
                <div className="checkmark_circle" />
                <div className="checkmark_stem" />
                <div className="checkmark_kick" />
              </span>
            ) : (
              <span className="checkmark_red">
                <div className="checkmark_circle_red" />
                <div className="checkmark_stem_1" />
                <div className="checkmark_stem_2" />
              </span>
            )}
            <span className="OSShipContentDataLabel">
              {accommodation.name}{" "}
            </span>
          </div>
        );
      });
    }
    const { expanded, height, height_extra } = this.state;
    return (
      <Spring from={{ height: height }} to={{ height: expanded ? height + height_extra : height, opacity: expanded ? 1 : 0}}>
        {styles => this.renderCard(extraInfo, styles)}
      </Spring>
    );
  }
}

export default OSShipCard;



// WEBPACK FOOTER //
// ./src/components/OSShipCard/OSShipCard.js